var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88556 0.510194C2.06054 0.335474 2.27066 0.199938 2.50198 0.112565C2.73331 0.0251932 2.98056 -0.0120195 3.22736 0.00339337C3.47415 0.0188063 3.71486 0.0864929 3.93351 0.201968C4.15217 0.317442 4.34379 0.478068 4.49568 0.673201L6.29076 2.97931C6.61977 3.40233 6.73578 3.95335 6.60577 4.47338L6.05875 6.66348C6.03066 6.77692 6.03229 6.89569 6.06347 7.00832C6.09465 7.12096 6.15433 7.22365 6.23676 7.30651L8.69387 9.76362C8.77682 9.84621 8.87969 9.90599 8.99251 9.93718C9.10534 9.96836 9.22431 9.96989 9.3379 9.94163L11.527 9.3946C11.7837 9.33081 12.0514 9.32601 12.3102 9.38057C12.569 9.43513 12.812 9.54763 13.0211 9.70962L15.3272 11.5037C16.1562 12.1487 16.2322 13.3738 15.4902 14.1148L14.4561 15.1489C13.7161 15.8889 12.61 16.2139 11.579 15.8509C8.93955 14.9234 6.54331 13.4125 4.56868 11.4307C2.58696 9.45635 1.07607 7.06046 0.148478 4.42137C-0.213539 3.39133 0.111476 2.28428 0.85151 1.54424L1.88556 0.510194Z",
    fill: "#606588"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.256e97636787d0d8259ee9ca1c1b31e7.svg";
export { ForwardRef as ReactComponent };